import { api } from '../api';

export const orderService = {
  create: (data: any) => api.post('/orders', data),
  listByUser: (userId: string) => api.get(`/orders/user/${userId}`),
  listByTenant: (tenantId: string) => api.get(`/orders/tenant/${tenantId}`),
  get: (id: string) => api.get(`/orders/${id}`),
  deliver: (id: string, data: any) => api.patch(`/orders/${id}/deliver`, data),
  remove: (id: string) => api.delete(`/orders/${id}`),
  pickup: (data: { token?: string; pin?: string }) => api.post('/orders/pickup', data),
  getQRCodeUrl: (id: string) => `/orders/${id}/qrcode`,
};